import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';
import { createReducer } from '../../../utils';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminOrganizationSubscriptionsReducer = createReducer<State, Actions>(initialState, {
  [actions.connectSubscription.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.connectSubscription.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.connectSubscription.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.connectSubscription.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default adminOrganizationSubscriptionsReducer;
